/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { getImportLogDetail } from "./ImportLogsHelper";
import moment from "moment";
import { Modal } from "react-bootstrap";
import Spin from "../../common/Spin";

const ImportLogDetail = ({
  importLogId,
  toggleShowModal,
  importLogModal,
  projectId,
}) => {
  const [importLogDetail, setImportLogDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const importLogRes = await getImportLogDetail(importLogId, projectId);
      setImportLogDetail(importLogRes);
      setLoading(false);
    }
    fetchData();
  }, [importLogId, projectId]);

  const Status = (id, description) => {
    if (id === 0 && description) {
      return `Chart of Account data not imported because ${description}`;
    } else {
      if (id === 1) {
        return "Chart of Account Created";
      } else {
        return "Chart of Account Updated";
      }
    }
  };

  const getVerifiedDateTime = (date) => {
    return moment(date).format("DD-MM-YYYY HH:mm:ss").toString();
  };

  return (
    <>
      <Modal
        size="lg"
        show={importLogModal}
        onHide={toggleShowModal}
        dialogClassName="modal-50w larg-popup review-popup small-review"
        aria-labelledby="contained-modal-title-vcenter"
        className="project-section"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          Chart Of Account Details
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <Spin />
          ) : (
            <>
              <div className="modal-content">
                {/* <h3>Chart Of Account Details</h3> */}
                <div className="modal-content-details">
                  {/* <div className="modal-content-left"> */}
                  <p>
                    <strong>Name:</strong>{" "}
                    {importLogDetail?.name ? importLogDetail?.name : "-"}
                  </p>
                  <p>
                    <strong>Type:</strong>{" "}
                    {importLogDetail?.type === 0 ? "Debit" : "Credit"}
                  </p>
                  <p>
                    <strong>Code:</strong>{" "}
                    {importLogDetail?.code ? importLogDetail?.code : "-"}
                  </p>
                  <p>
                    <strong>Subcode:</strong>{" "}
                    {importLogDetail?.sub_code
                      ? importLogDetail?.sub_code
                      : "-"}
                  </p>
                  <p>
                    <strong>Account Type:</strong>{" "}
                    {importLogDetail?.account_type
                      ? importLogDetail?.account_type
                      : "-"}
                  </p>
                  <p>
                    <strong>Tax Rate:</strong>{" "}
                    {importLogDetail?.tax === 1
                      ? "GST " +
                        (importLogDetail?.gst_percentage
                          ? importLogDetail?.gst_percentage
                          : 0) +
                        "%"
                      : importLogDetail?.tax === 2
                      ? "BAS Excluded"
                      : importLogDetail?.tax === 3
                      ? "GST on Imports"
                      : "GST Excluded"}
                  </p>
                  <p>
                    <strong>Accounting Code:</strong>{" "}
                    {importLogDetail?.accounting_code
                      ? importLogDetail?.accounting_code
                      : "-"}
                  </p>
                  <p></p>
                  <p
                    style={{
                      width: "100%",
                    }}
                  >
                    <strong>Description:</strong>{" "}
                    {importLogDetail?.description
                      ? importLogDetail?.description
                      : "BuildTrust"}
                  </p>
                </div>
              </div>
              <div className="modal-content">
                <h3>Sync</h3>
                <div className="modal-content-details">
                  <p>
                    <strong>Import From:</strong>
                    {importLogDetail?.import_from
                      ? importLogDetail?.xero_tenant_name
                        ? importLogDetail?.import_from +
                          `(${importLogDetail?.xero_tenant_name})`
                        : importLogDetail?.import_from
                      : ""}
                  </p>
                  <p>
                    <strong>Import Date:</strong>
                    {importLogDetail?.created_at
                      ? moment(
                          importLogDetail?.created_at,
                          "DD-MM-YYYY HH:mm:ss"
                        ).format("DD-MM-YYYY")
                      : "-"}
                  </p>
                  <p>
                    <strong>Imported by:</strong>
                    {importLogDetail?.imported_by
                      ? importLogDetail?.imported_by?.first_name &&
                        importLogDetail?.imported_by?.last_name
                        ? importLogDetail?.imported_by?.first_name +
                          " " +
                          importLogDetail?.imported_by?.last_name
                        : importLogDetail?.imported_by?.first_name
                        ? importLogDetail?.imported_by?.first_name
                        : importLogDetail?.imported_by?.last_name
                        ? importLogDetail?.imported_by?.last_name
                        : "-"
                      : "-"}
                  </p>
                  <p>
                    <strong>Last synchronised time:</strong>{" "}
                    {importLogDetail?.last_sync_date ? getVerifiedDateTime(importLogDetail?.last_sync_date) : "-"}
                  </p>
                  <p>
                    <strong>Note:</strong>
                    {importLogDetail?.status == null ||
                    importLogDetail?.status == ""
                      ? "-"
                      : Status(
                          parseInt(importLogDetail?.status),
                          importLogDetail?.description
                        )}
                  </p>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ImportLogDetail;
